// extracted by mini-css-extract-plugin
module.exports = {"friends":"styles_friends__VIdVg","avatar":"styles_avatar__auugI","name":"styles_name__1ryCO"};